var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/svg-macros.j2"] = require( "macros/svg-macros.j2" );
dependencies["product-visual-badge.j2"] = require( "product-visual-badge.j2" );
dependencies["carousel-slider/carousel-product-image-container.j2"] = require( "carousel-slider/carousel-product-image-container.j2" );
dependencies["carousel-slider/cta-paragraph.j2"] = require( "carousel-slider/cta-paragraph.j2" );
dependencies["carousel-slider/slider-product-image-container.j2"] = require( "carousel-slider/slider-product-image-container.j2" );
dependencies["carousel-slider/shadow-zoom.j2"] = require( "carousel-slider/shadow-zoom.j2" );
dependencies["product-video/product-video-badge.j2"] = require( "product-video/product-video-badge.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-image-viewer.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/product-image-viewer.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("imageUrl")) {
var t_4 = t_1.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_4);
if(t_1.hasOwnProperty("videoUrl")) {
var t_5 = t_1.videoUrl;
} else {
cb(new Error("cannot import 'videoUrl'")); return;
}
context.setVariable("videoUrl", t_5);
output += "\n";
env.getTemplate("macros/svg-macros.j2", false, "product/templates/product-image-viewer.j2", false, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
t_6.getExported(function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
if(t_6.hasOwnProperty("linkedSvg")) {
var t_9 = t_6.linkedSvg;
} else {
cb(new Error("cannot import 'linkedSvg'")); return;
}
context.setVariable("linkedSvg", t_9);
output += "\n\n";
var t_10;
t_10 = (lineno = 3, colno = 28, runtime.callWrap(t_4, "imageUrl", context, []));
frame.set("baseImageUrl", t_10, true);
if(frame.topLevel) {
context.setVariable("baseImageUrl", t_10);
}
if(frame.topLevel) {
context.addExport("baseImageUrl", t_10);
}
output += "\n";
var t_11;
t_11 = (lineno = 4, colno = 28, runtime.callWrap(t_5, "videoUrl", context, []));
frame.set("baseVideoUrl", t_11, true);
if(frame.topLevel) {
context.setVariable("baseVideoUrl", t_11);
}
if(frame.topLevel) {
context.addExport("baseVideoUrl", t_11);
}
output += "\n";
var t_12;
t_12 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productImageViewer")),"imageStyle");
frame.set("imageStyle", t_12, true);
if(frame.topLevel) {
context.setVariable("imageStyle", t_12);
}
if(frame.topLevel) {
context.addExport("imageStyle", t_12);
}
output += "\n";
var t_13;
t_13 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productImageViewer")),"colorCode");
frame.set("colorCode", t_13, true);
if(frame.topLevel) {
context.setVariable("colorCode", t_13);
}
if(frame.topLevel) {
context.addExport("colorCode", t_13);
}
output += "\n";
var t_14;
t_14 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"carousel")),"image_height");
frame.set("imageHeight", t_14, true);
if(frame.topLevel) {
context.setVariable("imageHeight", t_14);
}
if(frame.topLevel) {
context.addExport("imageHeight", t_14);
}
output += "\n";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"carousel")),"video_height");
frame.set("videoHeight", t_15, true);
if(frame.topLevel) {
context.setVariable("videoHeight", t_15);
}
if(frame.topLevel) {
context.addExport("videoHeight", t_15);
}
output += "\n";
var t_16;
t_16 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"productDetailMainImagePreset");
frame.set("preset", t_16, true);
if(frame.topLevel) {
context.setVariable("preset", t_16);
}
if(frame.topLevel) {
context.addExport("preset", t_16);
}
output += "\n";
var t_17;
t_17 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"displayName");
frame.set("altText", t_17, true);
if(frame.topLevel) {
context.setVariable("altText", t_17);
}
if(frame.topLevel) {
context.addExport("altText", t_17);
}
output += "\n";
var t_18;
t_18 = true;
frame.set("showControls", t_18, true);
if(frame.topLevel) {
context.setVariable("showControls", t_18);
}
if(frame.topLevel) {
context.addExport("showControls", t_18);
}
output += "\n\n";
var t_19;
t_19 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "primarySlice")),"sliceHashToIndex")),"code")),runtime.contextOrFrameLookup(context, frame, "colorCode"));
frame.set("currentPrimarySliceIndex", t_19, true);
if(frame.topLevel) {
context.setVariable("currentPrimarySliceIndex", t_19);
}
if(frame.topLevel) {
context.addExport("currentPrimarySliceIndex", t_19);
}
output += "\n";
var t_20;
t_20 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "primarySlice")),"sliceItems")),runtime.contextOrFrameLookup(context, frame, "currentPrimarySliceIndex"));
frame.set("currentPrimarySlice", t_20, true);
if(frame.topLevel) {
context.setVariable("currentPrimarySlice", t_20);
}
if(frame.topLevel) {
context.addExport("currentPrimarySlice", t_20);
}
output += "\n\n";
var t_21;
t_21 = (lineno = 16, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["quickshop.isOpen"]));
frame.set("isQuickshopOpen", t_21, true);
if(frame.topLevel) {
context.setVariable("isQuickshopOpen", t_21);
}
if(frame.topLevel) {
context.addExport("isQuickshopOpen", t_21);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "currentPrimarySlice")) {
output += "\n    ";
var t_22;
t_22 = env.getFilter("length").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentPrimarySlice")),"carouselCodes"),[]));
frame.set("carouselCodeCount", t_22, true);
if(frame.topLevel) {
context.setVariable("carouselCodeCount", t_22);
}
if(frame.topLevel) {
context.addExport("carouselCodeCount", t_22);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_23;
t_23 = 0;
frame.set("carouselCodeCount", t_23, true);
if(frame.topLevel) {
context.setVariable("carouselCodeCount", t_23);
}
if(frame.topLevel) {
context.addExport("carouselCodeCount", t_23);
}
output += "\n";
;
}
output += "\n\n<div class=\"o-row o-row--reverse c-product-image-viewer s-product-image-viewer dom-product-image-viewer\" data-qa-imagegrid>\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isQuickshopOpen")) {
output += "\n\n        ";
output += "\n        ";
var t_24;
t_24 = runtime.contextOrFrameLookup(context, frame, "True");
frame.set("disableZoom", t_24, true);
if(frame.topLevel) {
context.setVariable("disableZoom", t_24);
}
if(frame.topLevel) {
context.addExport("disableZoom", t_24);
}
output += "\n\n    ";
;
}
output += "\n\n    <div class=\"o-column o-extra-small--12 ";
if(!runtime.contextOrFrameLookup(context, frame, "quickshop") || !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen")) {
output += "o-large--10";
;
}
output += " o-carousel__wrapper ";
if(runtime.contextOrFrameLookup(context, frame, "carouselCodeCount") < 2) {
output += "o-carousel__single";
;
}
output += " js-main-carousel\">\n\n        ";
env.getTemplate("product-visual-badge.j2", false, "product/templates/product-image-viewer.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n        ";
env.getTemplate("carousel-slider/carousel-product-image-container.j2", false, "product/templates/product-image-viewer.j2", null, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
t_29.render(context.getVariables(), frame, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
output += t_30
output += "\n        ";
env.getTemplate("carousel-slider/cta-paragraph.j2", false, "product/templates/product-image-viewer.j2", null, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
t_33.render(context.getVariables(), frame, function(t_36,t_34) {
if(t_36) { cb(t_36); return; }
output += t_34
output += "\n\n    </div>\n\n    <div class=\"o-column o-extra-small--12 ";
if(!runtime.contextOrFrameLookup(context, frame, "quickshop") || !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen")) {
output += "o-large--2";
;
}
output += "\">\n        ";
env.getTemplate("carousel-slider/slider-product-image-container.j2", false, "product/templates/product-image-viewer.j2", null, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
t_37.render(context.getVariables(), frame, function(t_40,t_38) {
if(t_40) { cb(t_40); return; }
output += t_38
output += "\n    </div>\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "isQuickshopOpen")) {
output += "\n        ";
env.getTemplate("carousel-slider/shadow-zoom.j2", false, "product/templates/product-image-viewer.j2", null, function(t_43,t_41) {
if(t_43) { cb(t_43); return; }
t_41.render(context.getVariables(), frame, function(t_44,t_42) {
if(t_44) { cb(t_44); return; }
output += t_42
output += "\n    ";
})});
}
output += "\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"hasVideo")) {
output += "\n\n        ";
env.getTemplate("product-video/product-video-badge.j2", false, "product/templates/product-image-viewer.j2", null, function(t_47,t_45) {
if(t_47) { cb(t_47); return; }
t_45.render(context.getVariables(), frame, function(t_48,t_46) {
if(t_48) { cb(t_48); return; }
output += t_46
output += "\n\n    ";
})});
}
output += "\n\n\n</div>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-image-viewer.j2"] , dependencies)